import { render, staticRenderFns } from "./ReferenceMatchPie.vue?vue&type=template&id=4e12ce2e&scoped=true"
import script from "./ReferenceMatchPie.vue?vue&type=script&lang=ts"
export * from "./ReferenceMatchPie.vue?vue&type=script&lang=ts"
import style0 from "./ReferenceMatchPie.vue?vue&type=style&index=0&id=4e12ce2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e12ce2e",
  null
  
)

export default component.exports